import { SimpleTenant } from '../models/simple-tenant.model';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AdminSetupComponent } from '../../admin/admin-setup/admin-setup.component';

// Preserve existing destinations, permissions and counters in the footer panel.
@Component({
  selector: 'app-system-menu',
  standalone: false,
  templateUrl: './system-menu.component.html',
  styleUrls: ['./system-menu.component.scss']
})
export class SystemMenuComponent extends AdminSetupComponent {
  @Input() tenant: SimpleTenant;
  activeCategory: string | null = null;

  categoryLabel(category: string): string {
    const names: {[key: string]: [string, string]} = {
      MEMBERSHIP: ['People', 'الأشخاص'], SERVICES: ['Services & events', 'الخدمات والفعاليات'],
      CONTENT_MANAGEMENT: ['Content', 'المحتوى'], SYSTEM_SETTINGS: ['Settings', 'الإعدادات'],
      SUPER_ADMIN: ['Platform admin', 'إدارة المنصة']
    };
    return names[category] ? names[category][this.globalService.isRTL ? 1 : 0] : this.globalService.Get(category);
  }

  menuLabel(key: string): string {
    if (key === 'EVENTS') return this.globalService.Get('MANAGE_EVENTS');
    const labels: {[key: string]: string} = {
      GROUP_SETUP: 'Manage groups', GROUP_REQUESTS: 'Join requests', POINT_SYSTEM: 'Point systems', DIRECTORY: 'People directory', BIRTHDAY: 'Birthdays', NOTES: 'Private notes', SELECTIVE: 'Selective communication',
      COLLECTIVE: 'Collective communication', CATEGORIES: 'Ministries', POLICIES: 'Registration policies',
      CONFIGURE: 'Manage content', TAGS: 'Member tags', LINKS: 'Links', PERMISSIONS: 'User permissions',
      DATA_IMPORT: 'Import data', DATA_EXPORT: 'Export data', PAYMENT_ADAPTERS: 'Payment integrations',
      CHURCH_SETUP: 'Church details', FUND_TYPES: 'Fund types', SUBSCRIPTION: 'Subscription'
    };
    return !this.globalService.isRTL && labels[key] ? labels[key] : this.globalService.Get(key);
  }

  settingsGroupLabel(group: string): string {
    const arabic: {[key: string]: string} = {
      'People': 'الأشخاص', 'Activity': 'النشاط', 'Giving': 'التبرعات', 'Group management': 'إدارة المجموعات', 'Organization': 'التنظيم', 'Points': 'النقاط', 'Church': 'الكنيسة', 'Services': 'الخدمات', 'People & access': 'الأشخاص والصلاحيات',
      'Giving & payments': 'التبرعات والمدفوعات', 'Data & links': 'البيانات والروابط'
    };
    return this.globalService.isRTL ? arabic[group] || group : group;
  }

  actionIcon(action: string): string {
    const icons: {[key: string]: string} = {
      CallViewAccount:'fa-address-book', CallMembership:'fa-user-plus', CallBirthday:'fa-birthday-cake',
      CallSelectiveCommunication:'fa-comment', CallCommunication:'fa-comments', CallNotes:'fa-sticky-note',
      CallCalendar:'fa-calendar-alt', CallMyRegistrations:'fa-ticket-alt', CallEventReport:'fa-calendar-check',
      CallAttendance:'fa-user-check', CallServiceSetup:'fa-calendar-plus', CallDepartment:'fa-sitemap',
      CallSuperGroups:'fa-object-group', CallGroups:'fa-users', CallMyGroups:'fa-user-friends',
      CallGroupRequests:'fa-user-plus', callPointSystem:'fa-star', CallFormBuilder:'fa-edit',
      CallFormData:'fa-clipboard-check', CallMyForms:'fa-file-alt', CallFollowup:'fa-tasks',
      CallMyTasks:'fa-clipboard-list', CallNotifications:'fa-bell', CallVolunteering:'fa-hands-helping',
      CallMapDistribution:'fa-map-marked-alt', CallActivityChart:'fa-chart-line', CallDonationReport:'fa-chart-bar',
      CallDemographicsChart:'fa-chart-pie', CallCMS:'fa-layer-group', CallServiceGroup:'fa-church',
      CallServiceVenue:'fa-map-marker-alt', CallRegistrationGroup:'fa-clipboard-check', CallTags:'fa-tags',
      CallLinks:'fa-link', CallMemberPermission:'fa-key', CallImport:'fa-file-import',
      CallDataDownload:'fa-file-export', CallFundTypes:'fa-donate', CallPaymentAdapters:'fa-credit-card',
      CallShowSubscription:'fa-receipt', CallMyChurch:'fa-church', CallChurches:'fa-globe'
    };
    return icons[action] || 'fa-calendar-alt';
  }

  openCategory(category: string): void { this.activeCategory = category; }
  backToCategories(): void { this.activeCategory = this.activeCategory === 'COMMUNICATION' ? 'MEMBERSHIP' : null; }

  @Output() destinationSelected = new EventEmitter<void>();

  override async ngOnInit(): Promise<void> {
    this.isLoading = false;
    this.requests = 0;
    this.grpRequests = 0;

    this.cmsModule = this.tenant?.cmsModule === true;
    this.donationLink = this.tenant?.donationLink || null;
    this.churchWebsite = this.tenant?.churchWebsite || null;
    void this.loadFooterCounters();
  }

  // Opening navigation must preserve the current page title and state.
  override ngAfterViewInit(): void {}

  @HostListener('click', ['$event']) onDestinationClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).closest('button.system-destination:not([data-submenu]), button[data-destination]')) {
      this.destinationSelected.emit();
    }
  }
}
